import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Handle Global Token Expired (401)
      if (error.status === 401) {
        authService.refreshToken().subscribe({
          next: () => console.debug('Token silently refreshed after 401 response'),
          error: (err) => console.error('Failed to refresh token after 401', err)
        });
      }

      // Handle Global Forbidden/Permission Issue (403)
      if (error.status === 403) {
        messageService.add({
          severity: 'error',
          summary: 'Permission Denied',
          detail: 'You do not have permission to perform this action.'
        });
        authService.reloadScopes();
      }

      // Handle Global Rate Limiting (429)
      if (error.status === 429) {
        messageService.add({
          severity: 'error',
          summary: 'Rate Limit Exceeded',
          detail: 'Too many attempts. Please wait before trying again.'
        });
      }

      // Handle Global Server Errors (5xx)
      if (error.status >= 500 && error.status <= 504) {
        messageService.add({
          severity: 'error',
          summary: 'Server Error',
          detail: 'A server error occurred. Please try again later.'
        });
      }

      // Re-throw the error so component-level handling can take over for 4xx etc.
      return throwError(() => error);
    })
  );
};
